// ============================================================
// نمایش ساده‌ی یک موقعیت روی نقشه
//
// قبلاً فقط به tile.openstreetmap.ir وصل بود و آن سرویس از کار
// افتاده است، پس این کامپوننت در عمل همیشه پیام «نقشه در دسترس
// نیست» نشان می‌داد. حالا از منابع رایگانِ مشترک استفاده می‌کند و
// اگر اولی نداد، خودش به بعدی می‌رود.
// ============================================================

import React, { useState } from "react";
import { MapContainer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin } from "lucide-react";

import MapAutoSize from "./map/MapAutoSize";
import TileLayerWithFallback from "./map/TileLayerWithFallback";
import { MAX_ZOOM, pulsePin, useIsDarkMode } from "./map/tiles";

/** با عوض شدن مختصات، نقشه روی نقطه‌ی تازه می‌رود. */
const FollowPoint = ({ lat, lng }: { lat: number; lng: number }) => {
    const map = useMap();
    React.useEffect(() => {
        map.setView([lat, lng], 18);
    }, [map, lat, lng]);
    return null;
};

interface MapViewerProps {
    lat: number | null;
    lng: number | null;
}

const MapViewer: React.FC<MapViewerProps> = ({ lat, lng }) => {
    const dark = useIsDarkMode();
    const [failed, setFailed] = useState(false);

    if (lat == null || lng == null) {
        return <p className="text-gray-400">موقعیت مکانی ثبت نشده است.</p>;
    }

    return (
        <div className="w-full overflow-hidden border rounded-lg dark:border-gray-700">
            {!failed ? (
                <MapContainer
                    center={[lat, lng]}
                    zoom={18}
                    maxZoom={MAX_ZOOM}
                    scrollWheelZoom
                    // ردگیری resize به MapAutoSize سپرده شده — توضیحش آنجاست
                    trackResize={false}
                    style={{ height: "300px", width: "100%", zIndex: 1 }}
                >
                    <TileLayerWithFallback dark={dark} onExhausted={() => setFailed(true)} />
                    <Marker position={[lat, lng]} icon={pulsePin()} />
                    <MapAutoSize />
                    <FollowPoint lat={lat} lng={lng} />
                </MapContainer>
            ) : (
                <div className="flex flex-col items-center justify-center gap-2 p-4 bg-gray-100 dark:bg-gray-800 h-[300px] text-sm text-gray-500">
                    <MapPin size={32} className="text-red-500" />
                    <span>نقشه در حال حاضر در دسترس نیست</span>
                </div>
            )}

            <div className="flex items-center p-2 text-xs bg-gray-50 dark:bg-gray-900">
                <span className="text-gray-500">
                    <MapPin size={12} className="inline mr-1 text-red-500" />
                    <span dir="ltr">
                        {lat.toFixed(6)}، {lng.toFixed(6)}
                    </span>
                </span>
            </div>
        </div>
    );
};

export default MapViewer;
